import React, { useState, useEffect } from 'react';
import styled from 'styled-components';

import Section from './global/section';
import Button from './global/button';

import thankYou from '../../static/img/CMHA_ThankYou.svg';

const FormStyle = styled.div`
	section {
		background-image: url(/img/Green_Blob.svg);
		background-position: left 2rem;
		background-size: 25rem;
		background-repeat: no-repeat;
		position: relative;
		&::before {
			content: '';
			width: 0;
			height: 0;
			display: block;
			position: absolute;
			top: -1.25rem;
			left: 50%;
			transform: translateX(-50%);
			border-left: 1.26rem solid transparent;
			border-right: 1.26rem solid transparent;
			border-bottom: 1.26rem solid ${(p) => p.theme.color.teal};
		}
		.flex {
			display: flex;
			flex-wrap: wrap;
			width: 90%;
			margin: 0 auto;
			.form {
				width: 45%;
				.form-container {
					background-color: ${(p) => p.theme.color.purple};
					border-radius: 10px;
					padding: 1rem 1.5rem;
					p {
						margin-bottom: 0.75rem;
					}

					select,
					input,
					textarea {
						background-color: rgba(255, 255, 255, 0.3);
						width: 100%;
						margin-top: 0.75rem;
						padding: 0.5rem 1rem;
						resize: none;
						color: #fff;
						font-weight: 700;
						font-size: 0.9rem;
						&::placeholder {
							font-weight: 400;
							color: #fff;
						}
					}
					textarea {
						height: 10rem;
					}
					select {
						height: 2rem;
						border: none;
						border-radius: 0;
						padding-left: 2rem;
						color: #fff;
						font-family: ${(p) => p.theme.fonts.body};
						appearance: none;
						&::-ms-expand {
							display: none;
						}
						@media screen and (-ms-high-contrast: active),
							(-ms-high-contrast: none) {
							padding-left: 0;
						}
						option {
							color: #000;
						}

						background-image: url(/img/arrow-down.svg);
						background-repeat: no-repeat;
						background-position: left 0.75rem top 50%;
						background-size: 0.7rem auto;

						&.defaultValue {
							font-weight: 400;
						}
					}
					button {
						margin-top: 1rem;
					}
				}
			}

			.thanks {
				padding: 1rem 0;
				height: 100%;
				display: flex;
				flex-direction: column;
				align-items: center;
				justify-content: center;

				h2 {
					font-family: ${(p) => p.theme.fonts.body};
					font-size: 1.2rem;
					margin-bottom: 0.5rem;
					text-align: center;
				}

				p {
					font-size: 1.2rem;
					line-height: 1.7rem;
					text-align: center;
				}
			}

			.contact {
				width: 45%;
				max-width: 300px;
				margin-left: 10%;
				img {
					width: 100px;
					margin-bottom: 1rem;
				}
				.larger {
					font-size: 1.2rem;
					line-height: 1.7rem;
				}
				.person {
					margin-top: 1rem;
					p {
						font-size: 1.1rem;
						margin-bottom: 0.5rem;
					}
					a {
						display: inline-block;
						position: relative;
						margin-bottom: 0.25rem;
						&::after {
							content: '';
							background-color: #fff;
							transition: opacity 0.3s;
							width: 100%;
							height: 1px;
							position: absolute;
							bottom: 0;
							right: 0;
							opacity: 0;
						}
						&:hover::after {
							opacity: 1;
						}
					}
				}
				hr {
					background-color: ${(p) => p.theme.color.green};
					width: 100%;
					margin: 1.5rem 0;
				}
				.hotline {
					color: ${(p) => p.theme.color.green};
					transition: color 0.3s;
					font-size: 1.2rem;
					font-weight: 700;
					margin-top: 0.25rem;
					display: inline-block;
					position: relative;
					&::after {
						content: '';
						background-color: ${(p) => p.theme.color.green};
						transition: 0.3s opacity;
						width: 100%;
						height: 2px;
						position: absolute;
						bottom: -2px;
						right: 0;
						opacity: 0;
					}
					&:hover::after {
						opacity: 1;
					}
				}
			}
		}
	}
	@media all and (max-width: 900px) {
		section .flex {
			width: 100%;

			.form {
				width: 50%;
			}
			.contact {
				width: calc(50% - 4rem);
				margin-left: 4rem;
			}
		}
	}
	@media all and (max-width: 768px) {
		section .flex {
			width: 80%;
			.form {
				width: 100%;
			}
			.contact {
				width: 100%;
				margin-left: 0;
				max-width: none;
				margin-top: 3rem;
				img {
					width: 150px;
				}
			}
		}
	}
	@media all and (max-width: 500px) {
		section .flex {
			width: 100%;
		}
	}
`;

export default () => {
	const [thanks, setThanks] = useState(false);
	const [interest, setInterest] = useState('Unselected');
	const [selectionMade, setSelection] = useState(false);

	useEffect(() => {
		let query = window.location.search;

		// Thank You detection
		setThanks(query === '?thanks=true');

		// Autofill dropdown before a selection is made
		if (!selectionMade) {
			if (query === '?interest=host') {
				setInterest('Event Hosting');
				document.getElementById('interest').value = 'Event Hosting';
			}
			if (query === '?interest=corporate') {
				setInterest('Corporate Donation');
				document.getElementById('interest').value = 'Corporate Donation';
			}
			if (query === '?interest=donation') {
				setInterest('Donation');
				document.getElementById('interest').value = 'Donation';
			}
			if (query === '?interest=sponsor') {
				setInterest('Event Sponsoring');
				document.getElementById('interest').value = 'Event Sponsoring';
			}
		}
	});

	const dropdownChange = (e) => {
		setInterest(e.target.value);
		setSelection(true);
	};

	return (
		<FormStyle>
			<Section bg="teal" id="form">
				<div className="flex">
					<div className="form">
						{thanks && (
							<div className="thanks">
								<h2 className="bold">Thanks for contacting us!</h2>
								<p>
									A member of the Start Talking&trade; team will respond as soon
									as is possible.
								</p>
								<img src={thankYou} alt="" />
							</div>
						)}
						{!thanks && (
							<div className="form-container">
								<p>
									Fill out the form below and a member of the
									<strong> Start Talking</strong> team will respond as soon as
									possible.
								</p>
								<form
									name="Contact Form"
									method="post"
									data-netlify="true"
									action="/contact/?thanks=true#form"
									data-netlify-honeypot="bot-field"
								>
									<input type="hidden" name="form-name" value="Contact Form" />
									<input type="hidden" name="bot-field" />
									<label className="hide" htmlFor="interest">
										Interest:
									</label>
									<select
										className={interest === 'Unselected' ? 'defaultValue' : ''}
										id="interest"
										name="interest"
										onChange={(e) => dropdownChange(e)}
									>
										<option value="Unselected">I'm interested in...</option>
										<option value="Individual Donation">
											Individual Donations
										</option>
										<option value="Corporate Donation">
											Corporate Donations
										</option>
										<option value="Event Hosting">Hosting an Event</option>
										<option value="General">General Inquiry</option>
									</select>
									<label className="hide" htmlFor="firstname">
										First Name:
									</label>
									<input
										name="firstname"
										required
										type="text"
										id="firstname"
										placeholder="first name*"
									/>
									<label className="hide" htmlFor="lastname">
										Last Name:
									</label>
									<input
										name="lastname"
										required
										type="text"
										id="lastname"
										placeholder="last name*"
									/>
									<label className="hide" htmlFor="email">
										Email:
									</label>
									<input
										required
										type="email"
										id="email"
										name="email"
										placeholder="email*"
									/>
									<label className="hide" htmlFor="phone">
										Phone:
									</label>
									<input
										type="text"
										id="phone"
										name="phone"
										placeholder="phone"
									/>
									<label className="hide" htmlFor="message">
										Message:
									</label>
									<textarea
										required
										id="message"
										name="message"
										placeholder="message*"
									/>
									<Button type="submit" bg="teal">
										SUBMIT
									</Button>
								</form>
							</div>
						)}
					</div>
					<div className="contact">
						<img src="/img/white_bubble.svg" alt="white bubble" />
						<p className="larger">
							For more information please contact the
							<strong> Start Talking</strong> team:
						</p>
						<div className="person">
							<p className="bold">Liz Grummett</p>
							<a className="larger" href="tel:+17057265033">
								705-726-5033 ext 512
							</a>
							<a href="mailto:lgrummett@cmhastarttalking.ca">
								lgrummett@cmhastarttalking.ca
							</a>
						</div>
						<div className="person">
							<p className="bold">Lynne Raimondi</p>
							<a className="larger" href="tel:+17057265033">
								705-726-5033 ext 536
							</a>
							<a href="mailto:lraimondi@cmhastarttalking.ca">
								lraimondi@cmhastarttalking.ca
							</a>
						</div>
						<hr />
						<p className="larger">
							If you or someone you know needs support, call the
						</p>
						<p className="larger bold">Mental Health Crisis Line:</p>
						<a className="larger hotline" href="tel:+18888938333">
							1-888-893-8333
						</a>
					</div>
				</div>
			</Section>
		</FormStyle>
	);
};
